import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSelectedType } from 'EmailEditorUI/redux/selectors/selected';
import { BREAKPOINTS } from 'EmailEditorUI/constants/MobileEditingConstants';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
// @ts-expect-error no declarations found for module
import { hoverContentEvents } from 'LayoutBuilderUI/actions/userInterfaceActions';
import { getIsDraggingWithinApp } from 'LayoutBuilderUI/selectors/userInterface';
import { ELEMENT } from 'LayoutBuilderUI/lib/DragDropConstants';
import { useBreakpointContext } from 'EmailEditorUI/components/mo/BreakpointContext';
import { HideIcon } from 'foundations-assets/icons/components/HideIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledIndicator = styled.strong.withConfig({
  displayName: "HiddenElementIndicator__StyledIndicator"
})([".hs-private.hs-private.hs-private &{display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);padding:", ";font-size:", ";text-align:center;color:", ";font-weight:", ";z-index:6;width:100%;", "}"], ({
  theme
}) => `${theme.space['250']} ${theme.space['500']}`, ({
  theme
}) => theme.typography['body-200'].fontSize, ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.typography['body-125'].fontWeight, ({
  ignorePointerEvents
}) => {
  return ignorePointerEvents && css(["&{pointer-events:none;}"]);
});
function HiddenElementIndicator({
  variant = 'icon-and-text'
}) {
  const dispatch = useDispatch();
  const {
    breakpointName
  } = useBreakpointContext();
  const isDraggingWithinApp = useSelector(getIsDraggingWithinApp);
  const isSomethingSelected = useSelector(getSelectedType);

  /* Mouse events while there is a selection should be caught by the click catcher,
   * and when dragging they should be caught by any placeholder elements within
   * the section.
   */
  const ignorePointerEvents = Boolean(isSomethingSelected || isDraggingWithinApp);
  const handleMouseOver = () => {
    dispatch(hoverContentEvents[ELEMENT].mouseLeaveEvent());
  };
  const label = breakpointName === BREAKPOINTS.MOBILE ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "CrossFrame.elements.hiddenElementIndicator.mobile"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "CrossFrame.elements.hiddenElementIndicator.default"
  });
  return /*#__PURE__*/_jsx(NamespaceWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "hidden-element-indicator",
      onMouseOver: handleMouseOver,
      children: /*#__PURE__*/_jsxs(StyledIndicator, {
        ignorePointerEvents: ignorePointerEvents,
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(HideIcon, {
            size: "800"
          })
        }), variant === 'icon-and-text' && label]
      })
    })
  });
}
export default HiddenElementIndicator;